import { TableColumn, parseDefaultTableColumns } from '../../../../context/shared/tableColumns';
import { Project } from '../../../../domain/backoffice/project/Project';

export const projectsTableColumnKeys = [
  `name`,
  `company`,
  `users`,
  `max_vehicles`,
  `max_clients`,
  `max_services_plan`,
  `geo_fences`,
  `is_managed`,
  `traffic`,
  `created_at`,
] as const;

export type ProjectsTableColumnKeys = (typeof projectsTableColumnKeys)[number];

export type ProjectsTableColumn = TableColumn<ProjectsTableColumnKeys, Project>;

export const PROJECTS_DEFAULT_TABLE_COLUMNS: Array<ProjectsTableColumn> = [
  {
    identifier: `name`,
    type: `string`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `company`,
    type: `string`,
    displayable: true,
    filterable: true,
    sortable: false,
  },
  {
    identifier: `users`,
    type: `number`,
    displayable: true,
    filterable: false,
    sortable: false,
  },
  {
    identifier: `max_vehicles`,
    type: `number`,
    displayable: true,
    filterable: false,
    sortable: false,
  },
  {
    identifier: `max_clients`,
    type: `number`,
    displayable: true,
    filterable: false,
    sortable: false,
  },
  {
    identifier: `max_services_plan`,
    type: `number`,
    displayable: true,
    filterable: false,
    sortable: false,
  },
  {
    identifier: `geo_fences`,
    type: `number`,
    displayable: true,
    filterable: false,
    sortable: false,
  },
  {
    identifier: `is_managed`,
    type: `boolean`,
    displayable: true,
    filterable: false,
    sortable: false,
  },
  {
    identifier: `traffic`,
    type: `boolean`,
    displayable: true,
    filterable: false,
    sortable: false,
  },
  {
    identifier: `created_at`,
    type: `Date`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
];

export const getProjectsTableColumns = (): Array<ProjectsTableColumn> => {
  const storedTableColumns = localStorage.getItem(`BACKOFFICE_PROJECTS_TABLE_COLUMNS`);
  if (!storedTableColumns) return PROJECTS_DEFAULT_TABLE_COLUMNS;

  const parsedTableColumns = JSON.parse(storedTableColumns);

  // Final table columns should have the current ones.
  const finalTableColumns: Array<ProjectsTableColumn> = [
    ...(Array.isArray(parsedTableColumns) ? parsedTableColumns : []),
  ];

  return parseDefaultTableColumns({
    finalTableColumns,
    defaultTableColumns: PROJECTS_DEFAULT_TABLE_COLUMNS,
  });
};

export const setProjectsTableColumns = (tableColumns: Array<ProjectsTableColumn>) => {
  localStorage.setItem(`BACKOFFICE_PROJECTS_TABLE_COLUMNS`, JSON.stringify(tableColumns));
};
